import * as React from "react";
import * as S from "./messageRowImprove.styled";
import { Sparkles } from "lucide-react";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";

interface Props {
  content: string;
  onImprovePrompt?: () => void;
}

export const OpenChatMessageRowImprove: React.FC<Props> = ({ content, onImprovePrompt }) => {
  const { sendPromptToImprove } = usePromptGeneratorContext();

  const handleImprovePrompt = () => {
    onImprovePrompt?.();
    sendPromptToImprove(content);
  };

  return (
    <S.Container className="mt-1 flex rounded-md p-1 text-xs text-white" onClick={handleImprovePrompt}>
      <Sparkles size={14} className="mr-1" />
      Improve
    </S.Container>
  );
};
